// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__k6Qvj","title":"AfterFrontImage_title__2OI2t"};